<script setup>
import { useRoute } from 'vue-router'
import { useEntityPageTitle } from '@/composables/useEntityPageTitle'
import { useJobsStore } from '@/@vxapp/Jobs/useJobsStore'
import JobEditPage from '@/views/Previews/Jobs/JobEditPage.vue'
import { AccessPageMeta } from '@/access/accessPageMeta'

definePage({ meta: { ...AccessPageMeta.Projects.preview.meta, pageTitle: 'Project' } })

const route = useRoute()
const jobStore = useJobsStore()

useEntityPageTitle({
  entityName: 'Project',
  record: () => jobStore.job,
  recordGuid: job => job.jobGUID,
  identifier: job => job.name,
})
</script>

<template>
  <JobEditPage :key="route.params.guid" />
</template>
